import { Box, Typography } from '@mui/material'

const FirmDetails = ({ detail, key }) => {
  return (
    <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between',  py: 1 }}>
        <Typography variant="labelD" sx={{ minWidth: '30%', color: '#666'}}>
            {detail.display_name}
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'right' }}>
            {detail.display_value}
        </Typography>
    </Box>
  )
}

export default FirmDetails